var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _line, _path3, _rect7, _ellipse, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreYouSure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 210,
    viewBox: "0 0 216 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 211.008,
    height: 125.697,
    rx: 11.5013,
    transform: "matrix(1 0 0 -1 4.99219 160.371)",
    fill: "#82ADF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99219 132.236L216 132.236V46.1748C216 39.8228 210.851 34.6734 204.499 34.6734L16.4935 34.6734C10.1415 34.6734 4.99219 39.8227 4.99219 46.1748L4.99219 132.236Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43767,
    y: -1.43767,
    width: 208.133,
    height: 122.822,
    rx: 10.0637,
    transform: "matrix(1 0 0 -1 0 151.596)",
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6387,
    y: 195.765,
    width: 116.168,
    height: 14.0672,
    rx: 5.75067,
    fill: "#82ADF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.235 157.648H93.5733C92.3047 157.648 91.1859 158.479 90.8201 159.694L79.4111 197.58H141.806L130.235 157.648Z",
    fill: "#82ADF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.38544,
    height: 2.72203,
    rx: 1.36101,
    transform: "matrix(1 0 0 -1 13.1592 45.5631)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.38544,
    height: 2.72203,
    rx: 1.36101,
    transform: "matrix(1 0 0 -1 27.5605 45.5631)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.681,
    y: -0.681,
    width: 9.38544,
    height: 2.72203,
    rx: 1.36101,
    transform: "matrix(1 0 0 -1 41.9639 45.5631)",
    fill: "#153243",
    stroke: "#153243",
    strokeWidth: 1.362
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 133.067,
    x2: 211.008,
    y2: 133.067,
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.242 153.564H88.5811C87.3125 153.564 86.1937 154.395 85.8279 155.61L74.4189 193.497H136.814L125.242 153.564Z",
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0842,
    y: 194.027,
    width: 113.293,
    height: 11.1919,
    rx: 4.313,
    stroke: "#153243",
    strokeWidth: 2.87533
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.714,
    cy: 29.3669,
    rx: 29.3669,
    ry: 29.3669,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.58 29.3669C187.58 44.7573 175.104 57.2337 159.714 57.2337C144.323 57.2337 131.847 44.7573 131.847 29.3669C131.847 13.9764 144.323 1.5 159.714 1.5C175.104 1.5 187.58 13.9764 187.58 29.3669Z",
    stroke: "#153243",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.824 44.7814C155.263 44.7814 150.703 44.7802 146.142 44.7814C144.568 44.7814 143.266 44.229 142.394 42.879C141.53 41.5446 141.389 40.1049 142.136 38.6978C143.101 36.8805 144.167 35.1159 145.197 33.3323C148.836 27.0291 152.498 20.7405 156.108 14.4204C157.334 12.2738 159.625 11.7058 161.415 12.4038C162.438 12.8026 163.136 13.541 163.674 14.4753C166.834 19.9629 170.003 25.446 173.169 30.9313C174.593 33.3984 176.027 35.861 177.438 38.3359C178.725 40.5945 177.891 43.3338 175.555 44.3646C174.933 44.6402 174.192 44.759 173.504 44.7634C168.944 44.7971 164.383 44.7814 159.822 44.7814H159.824ZM162.073 23.5672C162.073 23.2792 162.09 23.0383 162.07 22.7997C161.986 21.7622 161.173 20.9242 160.147 20.8021C158.657 20.6251 157.493 21.8821 157.605 23.5055C157.757 25.7149 157.878 27.9254 158.016 30.1359C158.088 31.2899 158.127 32.4472 158.255 33.5945C158.348 34.4258 159.059 34.9692 159.878 34.9624C160.671 34.9557 161.352 34.4056 161.487 33.6102C161.554 33.2102 161.536 32.7968 161.56 32.3889C161.731 29.4323 161.904 26.4756 162.072 23.5672H162.073ZM159.824 40.9351C161.012 40.9654 162.014 40.0086 162.05 38.8064C162.09 37.5449 161.143 36.5198 159.918 36.4962C158.714 36.4727 157.688 37.4508 157.658 38.6496C157.626 39.8842 158.593 40.9038 159.824 40.9351Z",
    fill: "#FFF5DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.671 38.5768L176.672 38.5762C176.757 38.3247 176.801 38.1041 176.856 37.8217C176.883 37.6884 176.912 37.5412 176.95 37.3705V36.4805C176.806 35.5241 176.461 34.6281 175.946 33.7427L175.946 33.7424C174.335 30.9697 172.73 28.1902 171.126 25.4123C170.022 23.4994 168.918 21.5872 167.812 19.6784L167.812 19.6782C167.5 19.1388 167.191 18.6007 166.883 18.0645C165.888 16.3326 164.903 14.6194 163.859 12.9367L163.859 12.9366C162.841 11.2956 160.495 10.3552 158.504 10.7441L158.503 10.7442C156.726 11.091 155.455 12.0458 154.54 13.6348C152.981 16.3406 151.415 19.049 149.85 21.7565C148.485 24.1175 147.12 26.478 145.761 28.8355C145.432 29.4059 145.103 29.9623 144.777 30.512C143.945 31.9174 143.139 33.2784 142.442 34.7135M176.671 38.5768L142.442 34.7135M176.671 38.5768C175.83 41.0619 173.838 42.4862 171.199 42.4887L176.671 38.5768ZM142.442 34.7135L141.441 34.227L171.199 42.4887C167.556 42.4914 163.914 42.4908 160.271 42.4902C158.709 42.49 157.148 42.4897 155.586 42.4897C154.764 42.4897 153.942 42.4901 153.121 42.4904C151.274 42.4912 149.427 42.4921 147.581 42.4887C145.749 42.4854 144.283 41.857 143.196 40.4841C141.753 38.6601 141.462 36.7303 142.442 34.7135Z",
    stroke: "#FFCC47",
    strokeWidth: 2.22545
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.77 22.3752C160.601 25.2825 160.43 28.2403 160.258 31.197C160.235 31.6048 160.253 32.0182 160.185 32.4182C160.051 33.2136 159.37 33.7637 158.577 33.7705C157.758 33.7772 157.045 33.2338 156.953 32.4025C156.825 31.2552 156.786 30.0968 156.715 28.9439C156.577 26.7345 156.456 24.5229 156.303 22.3135C156.191 20.6901 157.355 19.4331 158.845 19.6101C159.872 19.7322 160.684 20.5703 160.768 21.6077C160.787 21.8452 160.771 22.0872 160.771 22.3752H160.77Z",
    fill: "#FFCC47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.524 39.2953C157.293 39.2639 156.326 38.2455 156.357 37.0097C156.387 35.8109 157.414 34.8328 158.618 34.8564C159.844 34.8799 160.79 35.905 160.75 37.1666C160.713 38.3676 159.712 39.3244 158.524 39.2953Z",
    fill: "#FFCC47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouSure);
export default __webpack_public_path__ + "static/media/are-you-sure.04f27777.svg";
export { ForwardRef as ReactComponent };